module.exports = __webpack_public_path__ + "img/79.ef2f0097.jpg";